// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, number, string } from 'prop-types'
import ACMTrigger from './ACMTrigger'

const Cell = props => {
  const {
    acmFlag,
    atpcEnabled,
    columnKey,
    idr,
    modulationSummary,
    segmentEndId,
    radioCode,
    TooltipTrigger,
  } = props

  return (
    <div className={'path-summary-site-cell'}>
      <ACMTrigger
        acmFlag={acmFlag}
        idRoot={idr}
        columnKey={columnKey}
        segmentEndId={segmentEndId}
        TooltipTrigger={TooltipTrigger} />
      <div
        className={'overflow-hidden margin-auto padding-left-half padding-right-half'}
        key={'radio-code-and-mod-info'}>
        <p
          className={'center-text text-ellipsis width-100'}
          id={`${idr}radio-code`}
          title={radioCode}>
          {radioCode}
        </p>
        <p
          className={'center-text text-ellipsis width-100'}
          id={`${idr}radio-modulation-summary`}
          title={modulationSummary}>
          {modulationSummary}
        </p>
      </div>
      <i
        key={'atpc-enabled-icon'}
        title={atpcEnabled ? `Automatic Transmit Power Control` : ``}
        className={'fa fa-bolt text-orange'}
        style={{opacity: atpcEnabled ? '1' : '0'}} />
    </div>
  )
}

Cell.propTypes = {
  acmFlag: bool.isRequired,
  atpcEnabled: bool.isRequired,
  columnKey: string.isRequired,
  idr: string.isRequired,
  modulationSummary: string.isRequired,
  segmentEndId: number.isRequired,
  radioCode: string.isRequired,
  TooltipTrigger: func.isRequired,
}

export default Cell
